import { normalize } from "normalizr";
import endpoints from "api/endpoints";
import Immutable from "immutable";
import { payment as paymentSchemas } from "schemas";

export default ({ resultKey = "payment" } = { resultKey: "payment" }) => ({
  url: endpoints.getPaymentUrl(),
  transform: (response) =>
    normalize(response.data, paymentSchemas.arrayOfPaymentSchemas).entities,
  transformResult: (response) => ({
    [resultKey]: normalize(response.data, paymentSchemas.arrayOfPaymentSchemas)
      .result,
  }),
  queryKey: endpoints.getPaymentUrl(),
  meta: {
    authToken: true,
  },
  force: true,
  options: {
    headers: {
      Accept: "application/json",
    },
  },
  update: {
    payment: (prevPayment = Immutable.Map(), payment) =>
      prevPayment.mergeDeep(payment),
  },
  updateResult: {
    [resultKey]: (prevResult, result) => result,
  },
});
